import React, { Component } from "react";
// import Stepper from "react-stepper-horizontal";
import { Stepper } from "react-form-stepper";
import { Link } from "react-router-dom";
import style from "./Type.module.css";
import history from "../../../utils/history";
import ttmLoader from "../../../assets/images/ttm-loader.gif";

export class Type extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isScreenLoaded: false
    };
  }

  componentDidMount = () => {
    setTimeout(() => {
      this.setState({
        isScreenLoaded: true,
      });
  }, 500);
  }

  // Handle back button
  backHandleClick = () => {
    history.push("/contacts");
  };

  goNextStpe2 = () => {
    this.props.navigateNextStep1();
  };
  goNextStpe3 = () => {
    this.props.navigateNextStep2();
  };
  goNextStpe4 = () => {
    this.props.navigateNextStep3();
  };

  render() {
    if(!this.state.isScreenLoaded){
        return(
        <div className="dashboard-loader">
              <img src={ttmLoader} alt="loader" className="loader-image" />
          </div>
          );
    }
    return (
      <React.Fragment>
        <div className={style.typeMainWrapper}>
          <div className={style.headingWrapper}>
            <h2>Step 1 : Contact Creation - Type</h2>
            <p>
             Select whether the Contact is an Individual or an Organisation or an External Practitioner.
            </p>
            <hr />
          </div>
          <div className="row">
            <div className="col-md-8 col-lg-6 col-xl-6">
              <div className="custom-stepper">
                <ul>
                  <li>
                    <h3 className="active">1</h3>
                  </li>
                  <li>
                    <h3 onClick={this.goNextStpe2}>2</h3>
                  </li>
                  <li>
                    <h3 onClick={this.goNextStpe3}>3</h3>
                  </li>
                  <li>
                    <h3 onClick={this.goNextStpe4}>4</h3>
                  </li>
                </ul>
              </div>
              {/* <div className="custom-stepper">
                <div className={style.stepperWrapper}>
                  <Stepper
                    steps={[
                      { label: "" },
                      { label: "" },
                      { label: "" },
                      { label: "" },
                    ]}
                    activeStep={0}
                    styleConfig={{
                      inactiveBgColor: "#fff",
                      activeBgColor: "#00467F",
                      inactiveTextColor: "#00467F",
                      activeTextColor: "#fff",
                      completedBgColor: "#fff",
                      completedTextColor: "#00467F",
                    }}
                    connectorStyleConfig={{
                      disabledColor: "#00467F33 ",
                      size: 2,
                    }}
                  />
                </div>
              </div> */}
            </div>
          </div>
          <div className={style.typeFormWrapper}>
            <h4>
              Contact Type <span className="mandatory">*</span>
            </h4>
            <div className="custom-control custom-radio mb-2">
              <input
                type="radio"
                className="custom-control-input"
                id="individual"
                name="partyType"
                checked={this.props.values.partyType === "individual"}
                onChange={this.props.handleChange}
                value="individual"
              />
              <label className="custom-control-label" htmlFor="individual">
                Individual
              </label>
            </div>
            <div className="custom-control custom-radio mb-2">
              <input
                type="radio"
                className="custom-control-input"
                id="company"
                name="partyType"
                onChange={this.props.handleChange}
                checked={this.props.values.partyType === "organization"}
                value="organization"
              />
              <label className="custom-control-label" htmlFor="company">
                Organisation/Company
              </label>
            </div>
            <div className="custom-control custom-radio mb-2">
              <input
                type="radio"
                className="custom-control-input"
                id="external_practitioner"
                name="partyType"
                onChange={this.props.handleChange}
                checked={this.props.values.partyType === "external_practitioner"}
                value="external_practitioner"
              />
              <label className="custom-control-label" htmlFor="external_practitioner">
                External Practitioner/Provider
              </label>
            </div>
            <hr className={style.formBottomLine} />
            <div
              className={` d-flex
              justify-content-between
              flex-column-reverse
              flex-md-row
              align-items-center ${style.btnWrapper}`}
            >
              <button
                type="button"
                className="btn form-primary-btn mb-3"
                onClick={this.backHandleClick}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn form-primary-btn mb-3"
                onClick={this.props.navigateNext}
                disabled={!this.props.values.partyType}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Type;
